import type { MockStat } from './types.ts';

export interface MockStatGridProps {
  readonly stats: readonly MockStat[];
}

/**
 * Lưới stat card.
 *
 * Dưới `md` xuống **2 cột** (`reference.md` §2.2): ở 360px, 4 cột cho mỗi card 78px và số cỡ
 * `--text-stat` (26px) vỡ chữ. Đây là một trong hai chỗ mà thiết kế 1440px không co được.
 */
export function MockStatGrid({ stats }: MockStatGridProps) {
  return (
    <div className="grid grid-cols-2 gap-3.5 md:grid-cols-4">
      {stats.map((stat) => (
        <div key={stat.label} className="rounded-card-sm border border-ink-100 bg-surface p-4">
          <div className="font-numeric text-stat font-bold text-brand-600">{stat.value}</div>
          <div className="mt-1 text-caption leading-[normal] text-ink-600">{stat.label}</div>
        </div>
      ))}
    </div>
  );
}
